<template>
  <div class="tw-flex tw-w-full tw-flex-col tw-items-center">
    <h2
      v-if="!composite"
      class="question-title-v2 tw-mb-6 tw-text-center"
    >
      {{ question.question }}
    </h2>
    <textarea
      v-model="answer"
      class="tw-w-full tw-max-w-xl tw-resize-y tw-rounded-lg tw-bg-light-gray tw-p-4 tw-text-onyx tw-outline-none"
      rows="6"
      :placeholder="question.placeholder || 'Write something'"
    ></textarea>
    <button
      type="button"
      class="tw-mt-6 tw-rounded-lg tw-bg-lavender-purple tw-px-12 tw-py-3 tw-font-atten-bold tw-uppercase tw-tracking-widest tw-text-white disabled:tw-opacity-60"
      :disabled="disabled"
      @click="submitAnswer"
    >
      Continue
    </button>
  </div>
</template>

<script>
/**
 * Renders an `answertype: 'text'` follow-up question (free-text answer).
 * Honours `allowempty` and `placeholder`. Emits `alert` when an empty answer
 * is rejected so the orchestrator can surface a message.
 */
export default {
  name: 'FollowupV7Text',

  props: {
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    composite: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      answer: '',
    };
  },

  watch: {
    question: {
      handler() {
        this.answer = this.question.answer || '';
      },
      deep: true,
    },
  },

  mounted() {
    if (this.question.answer) {
      this.answer = this.question.answer;
    }
  },

  methods: {
    submitAnswer() {
      if (this.answer.trim() === '' && !this.question.allowempty) {
        this.$emit('alert', 'The text field cannot be empty');
        return;
      }
      this.$emit('submitAnswer', this.question.id, this.answer || '');
    },
  },
};
</script>
